<div class="container-fluid animation-fadein " [ngClass]="rootClassName">
  <div class="form-step">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Contacto</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Certificado</span>
      </div>
    </div>
  </div>
  <span style="line-height: normal;font-size: 11px;display: block;" class="web-none text-bold text-center p-3">Por favor, verifique y confirme la información del pasajero a
    continuación. Asegúrese de que los datos sean correctos antes de continuar con su
    activación.</span>
  <div class="form-section">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
    <form novalidate class="p-4 form-general-style mb-4 mobile-form-padding" [formGroup]="stepNineForm">
      <div class="p-3 background-effect mb-16px mobile-none">
        <span style="line-height: normal;font-size: 11px;display: block;">Por favor, verifique y confirme la información del pasajero a
        continuación. <br>Asegúrese de que los datos sean correctos antes de continuar con su
        activación.</span>
      </div>
      <div class="row formControlRow date mb-16px">
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepNineForm" controlName="dayNacimiento" id="dayNacimiento" label="Día Nacimiento"  [submitted]="submitted" errorMessage="Día Nacimiento" ></app-input-field>
          <!-- <div class="form-group">
            
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Día Nacimiento"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="firstName" class="form-input-label">Día Nacimiento</label>
          </div> -->
        </div>
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepNineForm" controlName="mesNacimiento" id="mesNacimiento" label="Mes Nacimiento"
            [submitted]="submitted" errorMessage="Mes Nacimiento"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Mes Nacimiento"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Mes Nacimiento</label>
          </div> -->
        </div>
        <div class="dateFormControlContainer col form-small-label">
          <app-input-field [formGroup]="stepNineForm" controlName="yearNacimiento" id="yearNacimiento" label="Año Nacimiento"
            [submitted]="submitted" errorMessage="Año Nacimiento"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Año Nacimiento"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Año Nacimiento</label>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepNineForm" controlName="primerNombre" id="primerNombre" label="Primer Nombre"
            [submitted]="submitted" errorMessage="Primer Nombre"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Primer Nombre"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Primer Nombre</label>
          </div> -->
        </div>
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepNineForm" controlName="apellidosDelTitular" id="apellidosDelTitular" label="Apellidos del Titular" [submitted]="submitted" errorMessage="Apellidos del Titular"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Apellidos del Titular" onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Apellidos del Titular</label>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-md-6">
          <app-input-field [formGroup]="stepNineForm" controlName="pasaporteNoCédula" id="pasaporteNoCédula"
            label="Pasaporte o No Cédula" [submitted]="submitted" errorMessage="Pasaporte o No Cédula"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Pasaporte o No Cédula"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Pasaporte o No Cédula</label>
          </div> -->
        </div>
        <div class="formControlContainer col-12 col-md-6">
          <!-- <app-input-field [formGroup]="stepNineForm" controlName="pais" id="pais"
            label="País" [submitted]="submitted" errorMessage="País"></app-input-field> -->
            <app-dropdown 
              [formGroup]="stepNineForm" 
              [options]="countries" 
              formControlName="pais"
              controlName="pais"
              optionSelected="stepNineForm.controls['pais'].value"
              icon="/assets/external/localization-vector.svg"
              label="País"
              errorMessage="País"
              [submitted]="submitted"
              >
            </app-dropdown>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="País"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">País</label>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow date mb-16px">
        <div class="full-width-on-mobile mobile-mb-16px dateFormControlContainer col">
          <div class="form-group pt-0">
            <app-dropdown [options]="countriesCode" formControlName="phoneCode" label="Código *"
              icon="/assets/external/localization-vector.svg">
              <ng-template #optionTemplate let-item>
                <div class="d-flex align-items-center">
                  <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item?.name }}">
                  <span>{{ item?.code }} {{ item?.phoneCode ? ' (' + item?.phoneCode + ')' : '' }}</span>
                </div>
              </ng-template>
            </app-dropdown>
            <!-- <input type="text" class="form-control form-input input-form-full-space" formControlName="Primer Nombre"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="firstName" class="form-input-label">Código País</label> -->
          </div>
        </div>
        <div class="full-width-on-mobile mobile-mb-16px dateFormControlContainer col">
          <app-input-field [formGroup]="stepNineForm" controlName="telefonoMovil" id="telefonoMovil" label="Teléfono Móvil" [submitted]="submitted" errorMessage="Teléfono Móvil"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Teléfono Móvil"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Teléfono Móvil</label>
          </div> -->
        </div>
        <div class="full-width-on-mobile dateFormControlContainer col">
          <app-input-field [formGroup]="stepNineForm" controlName="telefonoFijo" id="telefonoFijo" label="Teléfono Fijo"
            [submitted]="submitted" errorMessage="Teléfono Fijo"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Teléfono Fijo"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Teléfono Fijo</label>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="col-12 col-md-12">
          <app-input-field [formGroup]="stepNineForm" controlName="direccionDeResidencia" id="direccionDeResidencia" label="Dirección de Residencia Permanente"
            [submitted]="submitted" errorMessage="Dirección de Residencia Permanente"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Dirección de Residencia Permanente"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Dirección de Residencia Permanente</label>
          </div> -->
        </div>
      </div>
      <div class="row formControlRow date mb-16px">
        <div class="full-width-on-mobile mobile-mb-16px dateFormControlContainer col">
          <app-input-field [formGroup]="stepNineForm" controlName="ciudad" id="Ciudad" label="Ciudad"
            [submitted]="submitted" errorMessage="Ciudad"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Ciudad"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="firstName" class="form-input-label">Ciudad</label>
          </div> -->
        </div>
        <div class="full-width-on-mobile mobile-mb-16px dateFormControlContainer col">
          <app-input-field [formGroup]="stepNineForm" controlName="estado" id="Estado" label="Estado" [submitted]="submitted"
            errorMessage="Estado"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Estado"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Estado</label>
          </div> -->
        </div>
        <div class="full-width-on-mobile dateFormControlContainer col">
          <app-input-field [formGroup]="stepNineForm" controlName="codigoPostal" id="códigoPostal" label="Código Postal" [submitted]="submitted"
            errorMessage="Código Postal"></app-input-field>
          <!-- <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="Código Postal"
              onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Código Postal</label>
          </div> -->
        </div>
      </div>
      <!-- <div class="row dob-section">
      </div>   -->
      <div class="form-group mb-0">
        <button type="submit" (click)="nextStep()" class="btn btn-primary continue-btn-steps py-3">Continuar</button>
      </div>
    </form>
    <div class="form-right-section form-itams">
      <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
    </div>
    <a href="javascript:void(0)" (click)="prevStep()" class="back-link">
      < Atrás</a>
    <div class="copy-right">
      <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com" target="_blank">www.wemarkforyou.com</a>. </p>
      <h5>Politica de privacidad</h5>
    </div>
  </div>
  <!-- <span class="quote-step10-text DesK,P4,Regular,16">
    <span>
      <span>
        Por favor, verifique y confirme la información del pasajero a
        continuación.
        <span [innerHTML]="raw7pyg"></span>
      </span>
      <br />
      <span>
        Asegúrese de que los datos sean correctos antes de continuar con su
        activación.
        <span [innerHTML]="raw3jef"></span>
      </span>
    </span>
  </span>
  <div class="quote-step10-frame566">
    <div class="quote-step10-frame274">
      <div class="quote-step10-frame1095 form-group">
        <div class="quote-step10-frame168">
          <div class="quote-step10-frame165">
            <span class="quote-step10-text05 Desk,P4,Bold.14">
              <span>Primer Nombre</span>
            </span>
          </div>
          <div class="quote-step10-frame169">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder"
              class="quote-step10-input"
            />
          </div>
        </div>
        <div class="quote-step10-frame174">
          <div class="quote-step10-frame16501">
            <span class="quote-step10-text07 Desk,P4,Bold.14">
              <span>Apellidos del titular</span>
            </span>
          </div>
          <div class="quote-step10-frame16901">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder1"
              class="quote-step10-input01"
            />
          </div>
        </div>
      </div>
      <div class="quote-step10-frame1096 form-group">
        <div class="quote-step10-frame1681">
          <div class="quote-step10-frame16502">
            <span class="quote-step10-text09 Desk,P4,Bold.14">
              <span>Fecha de Nacimimiento</span>
            </span>
          </div>
          <div class="quote-step10-frame16902">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder2"
              class="quote-step10-input02"
            />
          </div>
        </div>
        <div class="quote-step10-frame173">
          <div class="quote-step10-frame16503">
            <span class="quote-step10-text11 Desk,P4,Bold.14">
              <span>Email</span>
            </span>
          </div>
          <div class="quote-step10-frame16903">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder3"
              class="quote-step10-input03"
            />
          </div>
        </div>
      </div>
      <div class="quote-step10-frame1100 form-group">
        <div class="quote-step10-frame1682">
          <div class="quote-step10-frame16504">
            <span class="quote-step10-text13 Desk,P4,Bold.14">
              <span>Teléfono Móvil</span>
            </span>
          </div>
          <div class="quote-step10-frame16904">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder4"
              class="quote-step10-input04"
            />
          </div>
        </div>
        <div class="quote-step10-frame1731">
          <div class="quote-step10-frame16505">
            <span class="quote-step10-text15 Desk,P4,Bold.14">
              <span>Teléfono Fijo</span>
            </span>
          </div>
          <div class="quote-step10-frame16905">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder5"
              class="quote-step10-input05"
            />
          </div>
        </div>
      </div>
      <div class="quote-step10-frame1097 form-group">
        <div class="quote-step10-frame1683">
          <div class="quote-step10-frame16506">
            <span class="quote-step10-text17 Desk,P4,Bold.14">
              <span>Pasaporte o Cédula de identificación</span>
            </span>
          </div>
          <div class="quote-step10-frame16906">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder6"
              class="quote-step10-input06"
            />
          </div>
        </div>
        <div class="quote-step10-frame1732">
          <div class="quote-step10-frame16507">
            <span class="quote-step10-text19 Desk,P4,Bold.14">
              <span>País</span>
            </span>
          </div>
          <div class="quote-step10-frame16907">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder7"
              class="quote-step10-input07"
            />
          </div>
        </div>
      </div>
      <div class="quote-step10-frame1098">
        <div class="quote-step10-frame1684 form-group">
          <div class="quote-step10-frame16508">
            <span class="quote-step10-text21 Desk,P4,Bold.14">
              <span>Dirección de residencia permanente</span>
            </span>
          </div>
          <div class="quote-step10-frame16908">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder8"
              class="quote-step10-input08"
            />
          </div>
        </div>
      </div>
      <div class="quote-step10-frame1099">
        <div class="quote-step10-frame1685">
          <div class="quote-step10-frame16509">
            <span class="quote-step10-text23 Desk,P4,Bold.14">
              <span>Ciudad</span>
            </span>
          </div>
          <div class="quote-step10-frame16909">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder9"
              class="quote-step10-input09"
            />
          </div>
        </div>
        <div class="quote-step10-frame1733">
          <div class="quote-step10-frame16510">
            <span class="quote-step10-text25 Desk,P4,Bold.14">
              <span>Estado</span>
            </span>
          </div>
          <div class="quote-step10-frame16910">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder10"
              class="quote-step10-input10"
            />
          </div>
        </div>
        <div class="quote-step10-frame1741">
          <div class="quote-step10-frame16511">
            <span class="quote-step10-text27 Desk,P4,Bold.14">
              <span>Código Postal</span>
            </span>
          </div>
          <div class="quote-step10-frame16911">
            <input
              type="text"
              [attr.placeholder]="inputplaceholder11"
              class="quote-step10-input11"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="quote-step10-frame478">
    
    <button class="quote-step10-text31 DesK,P4,Regular,16" (click)="prevStep()">
      <span>&lt; Paso anterior</span>
    </button>
    <button type="submit" (click)="nextStep()" class="btn btn-primary continue-btn-steps py-3">Continuar</button>
  </div> 
  <div class="quote-step10-frame456">
    <span class="quote-step10-text33 Mob,P4,Intro,Light,10">
      <span>Cotizar</span>
    </span>
    <span class="quote-step10-text35 Mob,P4,Intro,Light,10">
      <span>Customizar</span>
    </span>
    <span class="quote-step10-text37 Mob,P4,Intro,Light,10">
      <span>Contacto</span>
    </span>
    <span class="quote-step10-text39 Mob,P4,Intro,Light,10">
      <span>Pago</span>
    </span>
    <span class="quote-step10-text41 Mob,P6-Intro-Bold">
      <span>Certificado</span>
    </span>
    <div class="quote-step10-progressbar"></div>
    <div class="quote-step10-progressbar1"></div>
    <div class="quote-step10-progressbar2"></div>
    <img
      [attr.alt]="ellipse25alt"
      [attr.src]="ellipse25src"
      class="quote-step10-ellipse25"
    />
    <img
      [attr.alt]="vectoralt"
      [attr.src]="vectorsrc"
      class="quote-step10-vector"
    />
    <img
      [attr.alt]="ellipse25alt1"
      [attr.src]="ellipse25src1"
      class="quote-step10-ellipse251"
    />
    <img
      [attr.alt]="vectoralt1"
      [attr.src]="vectorsrc1"
      class="quote-step10-vector1"
    />
    <img
      [attr.alt]="ellipse25alt2"
      [attr.src]="ellipse25src2"
      class="quote-step10-ellipse252"
    />
    <img
      [attr.alt]="vectoralt2"
      [attr.src]="vectorsrc2"
      class="quote-step10-vector2"
    />
    <img
      [attr.alt]="ellipse25alt3"
      [attr.src]="ellipse25src3"
      class="quote-step10-ellipse253"
    />
    <img
      [attr.alt]="vectoralt3"
      [attr.src]="vectorsrc3"
      class="quote-step10-vector3"
    />
    <img
      [attr.alt]="ellipse25alt4"
      [attr.src]="ellipse25src4"
      class="quote-step10-ellipse254"
    />
    <img
      [attr.alt]="vectoralt4"
      [attr.src]="vectorsrc4"
      class="quote-step10-vector4"
    />
  </div> -->
</div>
